import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WxArticleVO } from '@article/model/vo/wx-article.vo';
import { map } from 'rxjs/operators';
import { WagoApiClient } from '@shared/service/wago-api.client';
import { ModelConversionService } from '@shared/convert/model-conversion.service';
import { ExportArticleModelDTO } from '@article/model/vo/export-article-model.dto';
import { ArticleUtils } from '@article/util/article-utils';

@Injectable({
  providedIn: 'root'
})
export class ExportToolDataService {

  constructor(
    private wagoApiClient: WagoApiClient,
    private modelConversionService: ModelConversionService,
  ) { }

  public loadWxArticles(name: string): Observable<WxArticleVO[]> {
    if (ArticleUtils.isStringArticleId(name)) {
      return this.getWxArticlesByIds([+name]);
    } else {
      return this.getWxArticlesByArticleNumbers([name]);
    }
  }

  public getWxArticlesByIds(articleIds: number[]): Observable<WxArticleVO[]> {
    return this.wagoApiClient.post('article-export/export-tool/search/by-ids', articleIds).pipe(
      map((response) => this.modelConversionService.convertWxArticleVO(response)));
  }

  public getWxArticlesByArticleNumbers(articleNumbers: string[]): Observable<WxArticleVO[]> {
    return this.wagoApiClient.post('article-export/export-tool/search/by-numbers', articleNumbers).pipe(
      map((response) => this.modelConversionService.convertWxArticleVO(response)));
  }

  public executeSaveArticle(exportArticleModelDTO: ExportArticleModelDTO): Observable<void> {
    return this.wagoApiClient.post('article-export/export-tool/export-model', exportArticleModelDTO);
  }
}
